module.exports = __webpack_public_path__ + "static/media/logo-GALENO@2x.125cbe56.png";